import React from "react";
import ReferralCoordinator from "components/common/referralcoordinator/referralcoordinator";
const Referralcoordinator = () => {
  return (
    <>
      <div className="main-contents">
        <h1 className="heading-h5">Referral Coordinator</h1>
        <ReferralCoordinator />
      </div>
    </>
  );
};

export default Referralcoordinator;
